"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24CheckSquareFill = function Svg24CheckSquareFill(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.136 3c-.505 0-.996 0-1.412.034-.458.037-.997.125-1.54.402a4 4 0 0 0-1.748 1.748c-.277.543-.365 1.082-.402 1.54C3 7.14 3 7.63 3 8.136v7.728c0 .505 0 .996.034 1.412.037.458.125.997.402 1.54a4 4 0 0 0 1.748 1.748c.543.277 1.082.365 1.54.402C7.14 21 7.63 21 8.136 21h7.728c.505 0 .996 0 1.412-.034.458-.037.997-.125 1.54-.402a4 4 0 0 0 1.748-1.748c.277-.543.365-1.082.402-1.54.034-.416.034-.907.034-1.412V8.136c0-.504 0-.996-.034-1.412-.037-.458-.125-.997-.402-1.54a4 4 0 0 0-1.748-1.748c-.543-.277-1.082-.365-1.54-.402C16.86 3 16.37 3 15.864 3H8.136zm8.364 7.414A1 1 0 0 0 15.086 9L10.5 13.586 8.914 12A1 1 0 0 0 7.5 13.414l2.293 2.293a1 1 0 0 0 1.414 0l5.293-5.293z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg24CheckSquareFill.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24CheckSquareFill;
exports.default = _default;